import { FaTrashAlt } from "react-icons/fa";
import Tooltip from "../ToolTip";

const DeleteButton = ({ action, content, disabled = false}) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action()}
        disabled={disabled}
        className="p-1.5 text-red-500 hover:bg-red-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-red-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        <FaTrashAlt className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default DeleteButton;
